import VueSelect from './components/Select';
import mixins from './mixins/index';

export default VueSelect;
export { VueSelect, mixins };



// WEBPACK FOOTER //
// ./src/components/forks/select/index.js